/**
 * Lazy loaders for the content-page chunks.
 *
 * One module-level cache per route, shared by main.tsx (deep-link preload),
 * App.tsx (idle warm-up), and the page hosts (mount). Vite dedupes the
 * dynamic imports, so every caller resolves the same chunk.
 */
type Loader = { cached: any; inflight: Promise<any> | null; load: () => Promise<any> };

function makeLoader(importer: () => Promise<{ default: any }>): Loader {
  const l: Loader = {
    cached: null,
    inflight: null,
    load() {
      if (l.cached) return Promise.resolve(l.cached);
      if (!l.inflight) {
        l.inflight = importer().then((m) => {
          l.cached = m.default;
          return l.cached;
        });
      }
      return l.inflight;
    },
  };
  return l;
}

const flow = makeLoader(() => import("./components/HowItWorks"));
const philosophy = makeLoader(() => import("./components/Philosophy"));

export function getFlowPage() {
  return flow.cached;
}
export function loadFlowPage() {
  return flow.load();
}

export function getPhilosophyPage() {
  return philosophy.cached;
}
export function loadPhilosophyPage() {
  return philosophy.load();
}

/** Preload whichever lazy route `path` points at (no-op otherwise). */
export function preloadPath(path: string): Promise<any> {
  if (path === "/how-it-works") return flow.load();
  if (path === "/philosophy") return philosophy.load();
  return Promise.resolve(null);
}
